import { FilterCategory, FilterCollection } from "@/api/generatedTypes";
import { ArrowToggle } from "@/components/ui-components/ArrowToggler";
import { multiplyNoun } from "@/helpers/multiplyNoun";

import styles from "./AppliedFiltersCategory.module.scss";

interface AppliedFiltersCategoryProps {
  selectedCategory: FilterCategory | FilterCollection;
  selectOpened?: boolean;
  onClick?(): void;
  withArrow?: boolean;
}

const AppliedFiltersCategory = ({
  selectedCategory,
  selectOpened = false,
  onClick,
  withArrow,
}: AppliedFiltersCategoryProps) => {
  if (!selectedCategory) return;

  const name = withArrow
    ? multiplyNoun(selectedCategory.name)
    : selectedCategory.name;

  return (
    <div
      className={styles.select}
      onClick={onClick}
      id="applied_category_label"
    >
      <span>{name}</span>
      {withArrow && <ArrowToggle opened={selectOpened} />}
      {!withArrow && (
        <img
          src="/static/img/icons-v6/cross.svg"
          alt={`убрать фильтр ${name}`}
          className={styles.cross}
        />
      )}
    </div>
  );
};

export default AppliedFiltersCategory;
